import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ItemCategoria from './ItemCategoria';
import { ContextoAdminProtocolo } from './PrincipalAdminProtocolo';
const server = process.env.REACT_APP_SERVER;

function AdministrarCategoria() {
    const { regional, actualizar, setActualizar, info, setModalShow, areas } = useContext(ContextoAdminProtocolo);
    const [categorias, setCategorias] = useState([]);
    const [newCate, setNewCate] = useState(false);
    const [nombre, setNombre] = useState('');
    const [idArea,setIdArea] = useState(-1);
    function guardarCategoria(info) {
        console.log(info);
        fetch(`${server}/protocolos/modificarCategoriaPro`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'categoria': info
            })
        })
            .then(res => res.json())
            .then(data => {
                setModalShow(false);
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function guardarCategoriaN() {
        if (nombre !== '') {
            var aux = categorias.filter((item) => item.NOMBRE == nombre);
            console.log(aux);
            if (aux.length == 0) {
                fetch(`${server}/protocolos/addCategoriaProtocolo`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        regional, 'V_NOMBRE': nombre, 'V_ID': 0,'V_ID_AREA':idArea
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.ok) {
                            getCategoriaProtocolo();
                            setNombre('');
                            setNewCate(false);
                            MsgUtils.msgCorrecto(data.ok);
                        } else {
                            MsgUtils.msgError(data.error)
                        }
                    })
                    .catch(err => MsgUtils.msgError(err));
            } else {
                MsgUtils.msgError("Categoria Con mismo Nombre, no permitido !")
            }
        } else {
            MsgUtils.msgError("Ingrese el nombre de la Nueva Categoria");
        }
    }
    function cambiarArea(valor){
        setIdArea(valor);
    }
    function getCategoriaProtocolo() {
        fetch(`${server}/protocolos/getCategoriaProtocolo`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setCategorias(data.ok);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    useEffect(() => {
        getCategoriaProtocolo();
    }, [])
    return (
        <div className='table-responsive py-2'>
            <div className='input-group mb-3'>
                <label className='text-light my-auto mx-2 fw-bold' >Area</label>
                <select className="form-select form-select-sm bg-secondary text-light"
                    value={idArea} onChange={(e) => cambiarArea(e.target.value)}>
                    <option value={-1}>NINGUNO</option>
                    {areas.map((item, index) => {
                        return (
                            <option key={index} value={item.ID_CATEGORIA}>{item.CATEGORIA}</option>
                        )
                    })}
                </select>
            </div>
            <table className="table table-dark table-striped table-hover">
                <thead>
                    <tr>
                        <th className='col-4'>
                            Categoria
                            {newCate == false && <button className='btn btn-sm text-success fa-xl' onClick={() => setNewCate(true)}>
                                <i className="fa-solid fa-folder-plus"></i>
                            </button>}
                        </th>
                        <th className='text-end'>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {categorias.map((item, index) => {
                        if(idArea==item.ID_AREA||idArea==-1){
                            return (
                                <ItemCategoria categoria={item} collback={guardarCategoria} key={index} />
                            )
                        }
                    })}
                    {newCate &&
                        <tr>
                            <th className='col-4'>
                                <input type="text" className="form-control"
                                    placeholder="Nombre Categoria"
                                    value={nombre} onChange={(e) => setNombre(e.target.value.toUpperCase())}></input>
                            </th>
                            <td className='text-end'>
                                <div className='container-fluid'>
                                    <div className='btn-group'>
                                        <button className='btn btn-success' text="Guardar Categoria" onClick={() => guardarCategoriaN()}><i className="fa-solid fa-floppy-disk fa-xl"></i></button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default AdministrarCategoria